module.exports = __webpack_public_path__ + "img/thumb-choir.dfd09707.png";